import React from 'react';

import classNames from 'classnames';

import styles from './PredefinedButtons.module.scss';
import Button from '../Button';
import BackIcon from '../Icon/BackIcon';

type BackButtonProps = {
  className: string;
  onClick: () => void;
};

const BackButton = ({ className, onClick }: BackButtonProps) => (
  <Button className={classNames(styles.circle, styles.whiteBackground, className)} onClick={onClick} ariaLabel="Back">
    <BackIcon className={styles.greyFill} />
  </Button>
);

export default BackButton;
